import React from 'react';
import { CoreAPI } from '../../core';
import { CustomLayerPosition, ICustomLayer } from '../type';

/** 自定义图层 */
export class CustomLayer {
    /** 菜单数据 */
    private data: Set<ICustomLayer> = new Set();
    /** 快捷操作菜单打开事件 */
    private eventName = 'gs-render-custom-layer';

    constructor(private identity: string) {}

    /**
     * 添加自定义图层
     *
     * @param type - 类型
     * @param data - 数据
     * @param position - 位置
     */
    add(originIndex: number, type: string, node: React.ReactNode, position: CustomLayerPosition = 'bottom') {
        const item = {
            originIndex,
            type,
            node,
            position,
        };
        this.data.add(item);
        this.emitEvent();
        return item;
    }

    /** 移除自定义图层 */
    remove(item: ICustomLayer) {
        this.data.delete(item);
        this.emitEvent();
    }

    /** 监听自定义图层渲染 */
    onRender(callback: (data: ICustomLayer[]) => void) {
        const coreApi = CoreAPI(this.identity);
        const handler = coreApi.events.on(this.eventName, callback);

        return () => {
            coreApi.events.off(handler);
        };
    }

    /** 获取快捷操作菜单 */
    get() {
        return Array.from(this.data);
    }

    /** 销毁 */
    destroy() {
        this.data.clear();
        this.emitEvent();
    }

    private emitEvent() {
        CoreAPI(this.identity).events.emit(this.eventName, this.get());
    }
}
